var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImg = function SvgImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#888B94",
    d: "M7.296 2.242 6.707 1.9zM6.052 4.375v.682h.392l.197-.338zm9.896 0-.589.344.197.338h.392zm-1.244-2.133.589-.343zm-6.819.344c.236-.405.67-.654 1.139-.654V.568c-.954 0-1.836.507-2.317 1.33zM6.641 4.719l1.244-2.133-1.178-.687-1.244 2.133zm-3.016.338h2.427V3.693H3.625zM2.307 6.375c0-.728.59-1.318 1.318-1.318V3.693A2.68 2.68 0 0 0 .943 6.375zm0 9.75v-9.75H.943v9.75zm1.318 1.318c-.728 0-1.318-.59-1.318-1.318H.943c0 1.481 1.2 2.682 2.682 2.682zm14.75 0H3.625v1.364h14.75zm1.318-1.318c0 .728-.59 1.318-1.318 1.318v1.364c1.481 0 2.682-1.2 2.682-2.682zm0-9.75v9.75h1.364v-9.75zm-1.318-1.318c.728 0 1.318.59 1.318 1.318h1.364c0-1.481-1.2-2.682-2.682-2.682zm-2.427 0h2.427V3.693h-2.427zm-1.833-2.471 1.244 2.133 1.178-.687-1.244-2.133zm-1.139-.654c.47 0 .903.249 1.139.654l1.178-.687a2.68 2.68 0 0 0-2.317-1.33zm-3.952 0h3.952V.568H9.024z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.761,
    height: 6.761,
    x: 7.619,
    y: 7.557,
    stroke: "#888B94",
    strokeWidth: 1.364,
    rx: 3.381
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.563,
    height: 1.563,
    x: 16,
    y: 6.875,
    fill: "#888B94",
    rx: 0.781
  })));
};
export default SvgImg;